import { render, staticRenderFns } from "./zxpxxq.vue?vue&type=template&id=5ff412d5&scoped=true&"
import script from "./zxpxxq.vue?vue&type=script&lang=js&"
export * from "./zxpxxq.vue?vue&type=script&lang=js&"
import style0 from "./zxpxxq.vue?vue&type=style&index=0&id=5ff412d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff412d5",
  null
  
)

export default component.exports